import React, { Component } from 'react';
// import DesktopForm from './DesktopForm/DesktopForm';
// import MobileForm from './MobileForm/MobileForm';
import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import Helmet from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import Css from '@components/CustomizedProposal/DesktopForm/DesktopForm.scss';
import { Link } from 'react-router-dom';

class CustomizedProposal extends Component {
  state = {
    showMoreInfo: false,
    status: 0,
    formData: {
      FirstName: '',
      LastName: '',
      Email: '',
      Phone: '',
      howdidyouhearaboutJetSuite: '',
      Home_Airport__c: '',
      estimatedFlightHoursorofprivateflightsperyear: '',
      currentSolution: '',
      primaryTravelType: '',
      primaryDestinations: '',
      bestTimeforaRepresentativetoFollowUp: '',
      leadPartitionIDCustom: 'JS'
    }
  };

  componentDidMount = () => {
    window.addEventListener('marketo-submitted-customized-1043', () =>
      this.submitingHandler(2)
    );
    window.addEventListener('marketo-submitting-customized-1043', () =>
      this.submitingHandler(1)
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener('marketo-submitted-customized-1043', () =>
      this.submitingHandler(2)
    );
    window.removeEventListener('marketo-submitting-customized-1043', () =>
      this.submitingHandler(1)
    );
  };

  submitingHandler = status => {
    this.setState({
      status: status
    });

    if (status === 2) {
      setTimeout(() => {
        this.setState({
          showMoreInfo: false,
          status: 0,
          formData: {
            FirstName: '',
            LastName: '',
            Email: '',
            Phone: '',
            howdidyouhearaboutJetSuite: '',
            Home_Airport__c: '',
            estimatedFlightHoursorofprivateflightsperyear: '',
            currentSolution: '',
            primaryTravelType: '',
            primaryDestinations: '',
            bestTimeforaRepresentativetoFollowUp: '',
            leadPartitionIDCustom: 'JS'
          }
        });
      }, 2000);
    }
  };

  updateForm = (event, name) => {
    const currentData = { ...this.state.formData };
    currentData[name] = event.target.value;

    this.setState({
      formData: { ...currentData }
    });
  };

  submitHandler = () => {
    let myForm = window.marketo.getForm(1043);
    myForm.addHiddenFields({ ...this.state.formData });
    myForm.submitEvent = 'customized-1043';
    myForm.submit();
  };

  moreInfoClickHandler = event => {
    const showInfo = this.state.showMoreInfo;
    this.setState({
      showMoreInfo: !showInfo
    });
  };

  render() {
    let height = window.innerHeight;
    /*const readyToJoinProps = {
      screenHeight: height,
      className: 'panel d-flex align-items-center'
    };*/

    const isMobile = this.props.pageWidth < 992;
    let className = '';
    if (isMobile) {
      className = 'pt-5 mt-5 mb-5';
    } else {
      className = 'abs-container d-flex align-items-center h-100';
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Contact Us | JetSuite</title>
          <meta name="description" content={'Contact Us'} />
        </Helmet>
        <ScrollContainer pageHeight={height} hideNavDots={true}>
          <CloudPanel
            id={'contact-us'}
            hideJSILogo={true}
            screenHeight={this.props.pageHeight}
          >
            <div className={className}>
              <Container style={{ height: '70%', overflow: 'auto' }}>
                <Row className={'justify-content-center'}>
                  <Col className={'col-12 col-md-6'}>
                    <div className="p-4 background-white text-left">
                      <div
                        className={'text-center pb-4 pt-4'}
                        style={{ fontSize: '22px', fontWeight: '500' }}
                      >
                        This website is no longer active.
                      </div>
                      <div className={'pb-3'}>
                        <p className={'text-justify'}>
                          We have recently restructured and have resumed
                          operations and are now conducting charter operations
                          as Superior Air Charter. To inquire about chartering a
                          flight, please contact{' '}
                          <a
                            href={'linkto:charter@superior.flights'}
                            className={'color-red'}
                          >
                            charter@superior.flights
                          </a>
                          .
                        </p>
                        <p className={'text-justify'}>
                          If you're looking for information about JSX or to book
                          a seat via JSX, click{' '}
                          <a
                            href={'https://www.jsx.com'}
                            className={'color-red'}
                          >
                            here.
                          </a>
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </CloudPanel>
          {/* window.innerWidth > 991 ? (
            <DesktopForm
              {...readyToJoinProps}
              {...this.state}
              submitHandler={this.submitHandler}
              moreInfoClick={this.moreInfoClickHandler}
              updateForm={(event, name) => this.updateForm(event, name)}
            />
          ) : (
            <MobileForm
              id={'customized-proposal'}
              {...readyToJoinProps}
              {...this.state}
              submitHandler={this.submitHandler}
              moreInfoClick={this.moreInfoClickHandler}
              updateForm={(event, name) => this.updateForm(event, name)}
            />
          ) */}
        </ScrollContainer>
      </React.Fragment>
    );
  }
}
export default CustomizedProposal;



// WEBPACK FOOTER //
// ./src/components/CustomizedProposal/CustomizedProposal.jsx